/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, useMemo, useRef } from 'react';
import clsx from 'clsx';
import { StyledHotelCard } from './index.styles';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import { SearchResultDataNode, SearchStateStoreDataType } from '../../organisms/SearchResults/store/store.type';
import { PropertyCardPriceSection } from '../propertyCardPriceComponent';
import CommonUtils from '../../organisms/SearchResults/lib/CommonUtils';
import {
  DefaultValue,
  mandatoryFeeCodes,
  croppingRatio,
  outputQuality,
  outputInterpolation,
  HWSBrands,
  MARRIOTT_CACHE_URL,
  hardCodedAllLocale,
  STATUS_NOT_AVAILABLE,
  studioResCode,
  studisResCodeAriaLabel,
} from '../../organisms/SearchResults/index.constant';
import {
  checkThresholdPercentage,
  getCurrentPriceRateBlock,
  getCurrentRateStrikeThroughBlock,
  getCurrRateAmountBlock,
  getPriceByDecimalPoint,
  getCurrentRatePointsBlock,
  enableHotelList,
} from '../../organisms/SearchResults/lib/helper';
import { HQV_ACTIONS } from '../../reducers';
import { useRedirectionRules } from '../../hooks';
import { getClassForBreakpoint } from '@marriott/mi-ui-library-shop';
import { getBreakpoint } from '../../modules/utils/helpers';
import { ImageCarouselComponent } from '../../molecules/imageCarousel';
import { useHQVContext } from '../../context';
import { useConditionalPageContextSERP } from '../../hooks';
import { BREAKPOINT_LARGER_MOBILE, MILESTOMETERS } from '../../organisms/SearchResults/lib/application.constants';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';
import {
  localeToShowAllInclusiveBadge,
  reviewsRedirectionVarValue,
  STATUS_MAX_OCCUPANCY_EXCEEDED,
  trcRedirectionVarValue,
} from '../../constants';
import { SearchRateType } from '../../organisms/SearchResults/store/store.type';
import {
  useWindowSize,
  useCheckBreakpoint,
  LogoContainer,
  LogoContainerBackgroundColor,
  Badge,
  BadgeVariation,
} from '@marriott/mi-ui-library';
import { PropertyReview, PropertyRatingContainer, TOOLTIP_POSITION, CN_RATING_TOOLTIP } from '@marriott/mi-ui-library';
import { addSubDirectoryPrefix, isReviewCountHidden } from '../../utils/src/helper';
import { formatNumberByLocale, getCalculatedDistance } from '../../utils/src/utils';
import { NAVIGATION_URL_CONSTANTS } from '../../organisms/SearchResults/lib/config';
import SM from '../../organisms/HotelGalleryTitle/config';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';
import { isJpKoCnLocale } from '@marriott/shared/mi-helper-utils';
import {
  determineIfRatesPresent,
  fetchAndSetSelectedPropertyData,
  identifyTypeOfMandatoryFee,
} from '../../modules/utils/ratesHelper';
import { useSearchResultsStore } from '../../modules/store/searchResultsStore';
import { useHQVDatalayerTrackingStore } from '../../modules/store/hqvDatalayerTrackingStore';
import { formatOpeningSoonDate } from '../../modules/utils';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    // extends React's HTMLAttributes
    custom_click_track_value?: string;
  }
}

interface HotelProps {
  id: string;
  imageUrl: string;
  name: string;
  nameInDefaultLanguage?: string;
  stars: number | undefined;
  totalReviews: number;
  distance: number;
  description: string;
  price: SearchResultDataNode;
  hotelUnavailable: boolean;
  hotelUnavailableLabel: string;
  openingDate: string;
  points: SearchRateType | null;
  pointSavers: boolean | undefined;
  adultsOnly: boolean;
  currencyCode: string;
  duration: string;
  selected: () => void;
  nameUrl: string;
  reviewUrl: string;
  ratesUrl: string;
  availabilityUrl: string;
  index: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedHotelData: any;
  cardIndex: number;
  hotelPromoLabel: string;
  lengthOfStay: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  totalPrice: any;
  calltoBookLabel: string;
  openingSoonLabel: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  monthsArray: any;
  avgPerNightLabel: string;
  perNightLabel: string;
  adultsOnlyMessageLabel: string;
  removeChildrenMessage: string;
  pointsSaverLabel: string;
  pointsPerStayLabel: string;
  childCount: number;
  searchQueryContextValue: SearchStateStoreDataType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  staticContent?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleTooltipClickOnCard: (value: boolean) => any;
  flexibleSearch?: boolean;
  isHotelBookable?: boolean;
  brandImageUrl: string;
  carouselImages: any;
  idx: number;
  basicInformation: any;
  otherPropertyInformation: any;
  isSpecialRateSearch?: boolean;
  flexibleOrManyProperty: boolean;
  isErrorState: boolean;
  currentLocaleLang?: string;
  EEOPriceInfo?: any;
  priceInfo?: any;
  EEOTotalPrice?: any;
  ratesData?: any;
  options?: any;
  isFlexibleDateSearch?: boolean;
  editToSeeRatesLabel: string;
  maximumGuestsExceededLabel: string;
  editGuestsOrRoomsLabel: string;
  statusCode: string;
  seoNickname?: string;
  isMax?: boolean;
  noRatesAvailableForAnyProperty?: boolean;
  onOpenHotelPanel?: (propertyData: any, propertyId: string) => void;
}

export const HotelCard: React.FC<HotelProps> = ({ onOpenHotelPanel, ...props }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const {
    recentlyViewed,
    setRecentlyViewed,
    continueCtaProperty,
    jsonContent,
    isTaxesandFeesIncludedFromPopup,
    isErrorState,
    setIsErrorState,
    isMapViewEnabled,
  }: any = useConditionalSearchResultsRenderedDataSERP(renderedData);
  const { searchQueryState } = useConditionalSearchFilterContextWithSerpFlag();
  const { currentLocale, SESSION_APP_GET_CALL_URL, headersData, sessionData, featureFlagLogo, pageVal } =
    useConditionalPageContextSERP();
  const { hqvDispatch } = useHQVContext();
  const [nameElipsis, setNameElipsis] = useState(false);
  const [showStrikeThroughPrice, setShowStrikeThroughPrice] = useState<boolean>(false);
  const [showTaxesAndFees, setShowTaxesAndFees] = useState<boolean>(false);
  const [finalPrice, setFinalPrice] = useState<string | undefined>('');
  const [breakpoint, setBreakpoint] = useState<string | undefined>(getBreakpoint());
  const [recentlyViewedFlag, setRecentlyViewedFlag] = useState(false);
  const isViewportXS = useCheckBreakpoint('viewportXS');
  const isViewportM = useCheckBreakpoint('viewportM');
  const isViewportL = useCheckBreakpoint('viewportL');
  const isViewPortXL = useCheckBreakpoint('viewportXl');
  const host = headersData?.['x-host'];
  const currentLocaleLang = props.currentLocaleLang ?? currentLocale;
  const isFutureDate = props.openingDate ? isDateAfterToday(props.openingDate) : false;
  const openingDate: any = props?.openingDate;
  const clickTrackingLoc = 'Phoenix Search Results';
  const { width } = useWindowSize();
  const seoNickName = props?.price?.node?.property?.seoNickname ?? null;
  const isAdultOnlyEdgeCaseTriggered = props.adultsOnly && props.childCount > 0;
  const showFullPriceInSession = sessionData?.cacheData
    ? sessionData?.cacheData?.data?.AriesSearch?.searchCriteria?.showFullPrice
    : sessionData?.data?.AriesSearch?.searchCriteria?.showFullPrice;
  const showFullPriceInMiniCard = isTaxesandFeesIncludedFromPopup
    ? props.searchQueryContextValue.includeTaxesAndFees
    : showFullPriceInSession === 'true';

  const ratingContainer = isReviewCountHidden(currentLocale) ? 'm-ratings is-review-count-hidden' : 'm-ratings';
  const { envVarsObject } = useClientEnvVarsStore();
  const imageDomain = envVarsObject?.['UXL_IMAGE_CACHE_DOMAIN'] ?? MARRIOTT_CACHE_URL;

  const bodyRef = useRef<HTMLBodyElement | null>(null);
  const setSearchResultsState = useSearchResultsStore(
    (state: { setSearchResultsState: any }) => state.setSearchResultsState
  );
  const ratesDataFromStore = useSearchResultsStore((state: { ratesData: any }) => state.ratesData);
  const resetDatalayerTracking = useHQVDatalayerTrackingStore(state => state.resetStore);
  useEffect(() => {
    bodyRef.current = document.body as HTMLBodyElement;
  }, []);

  useEffect(() => {
    let currRate;
    let currEliteDiscountRate;
    let showStrikeThroughResult;
    //to reset the name elipsis to fix elipsis issue
    setNameElipsis(false);
    // If flexible dates not selected
    if (!props.isFlexibleDateSearch) {
      const rateNode = getCurrentPriceRateBlock(searchQueryState, props.ratesData);
      currRate = getCurrRateAmountBlock(rateNode);
    }
    if (props.options?.rateRequestTypes?.length === 3) {
      currRate = props.isFlexibleDateSearch
        ? null
        : props.ratesData?.filter(
            (key: { rateModes: { pointsPerUnit: { points: number } } }) => key.rateModes?.pointsPerUnit
          )[0];
    }
    if (props.options?.rateRequestTypes?.length === 2) {
      currEliteDiscountRate = props.isFlexibleDateSearch ? null : getCurrentRateStrikeThroughBlock(props.ratesData);
    }
    if (currRate?.totalAmount) {
      let priceInfo = currRate?.totalAmount;
      let EEOPriceInfo = currEliteDiscountRate?.totalAmount;

      if (searchQueryState.currentCurrency !== DefaultValue) {
        priceInfo = currRate?.totalAmount;
        EEOPriceInfo = currEliteDiscountRate?.totalAmount;
      }
      if (
        EEOPriceInfo &&
        EEOPriceInfo?.amount &&
        priceInfo &&
        priceInfo?.amount &&
        EEOPriceInfo?.amount < priceInfo?.amount
      ) {
        showStrikeThroughResult = checkThresholdPercentage(priceInfo?.amount, EEOPriceInfo?.amount);
        if (showStrikeThroughResult) {
          setNameElipsis(true);
        } else {
          setNameElipsis(false);
        }
      }
    } else {
      let priceInfo: any;
      // update logic for priceInfo depending on amountPlusMandatoryFees/amount
      if (currRate?.amountPlusMandatoryFees) {
        priceInfo = currRate?.amountPlusMandatoryFees;
      } else {
        priceInfo = currRate?.amount;
      }

      let EEOPriceInfo = currEliteDiscountRate?.amount;
      // update logic for priceInfo depending on amountPlusMandatoryFees/amount
      if (searchQueryState.currentCurrency !== DefaultValue) {
        if (currRate?.amountPlusMandatoryFees) {
          priceInfo = currRate?.amountPlusMandatoryFees;
        } else {
          priceInfo = currRate?.amount;
        }
        EEOPriceInfo = currEliteDiscountRate?.amount;
      }
      if (
        EEOPriceInfo &&
        EEOPriceInfo?.amount &&
        priceInfo &&
        priceInfo?.amount &&
        EEOPriceInfo?.amount < priceInfo?.amount
      ) {
        showStrikeThroughResult = checkThresholdPercentage(priceInfo?.amount, EEOPriceInfo?.amount);
        if (showStrikeThroughResult) {
          setNameElipsis(true);
        } else {
          setNameElipsis(false);
        }
      } else {
        setNameElipsis(false);
      }
    }
  }, [props.ratesData, props.options, props.isFlexibleDateSearch, props.selectedHotelData]);
  let edgeCaseTriggered = false;
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handlePropertyClicked = (id: string) => {
    const prevChecked = localStorage.getItem('recent')?.split(',') || '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const tempArr: any = [];
    if (recentlyViewed && recentlyViewed.length > 0) {
      if (!recentlyViewed.includes(id)) {
        if (prevChecked && prevChecked.length > 0) {
          setRecentlyViewed([...prevChecked, ...recentlyViewed, id]);
          tempArr.push([...prevChecked, ...recentlyViewed, id]);
        } else {
          setRecentlyViewed([...recentlyViewed, id]);
          tempArr.push([...recentlyViewed, id]);
        }
      }
    } else if (!prevChecked.includes(id)) {
      if (prevChecked && prevChecked.length > 0) {
        setRecentlyViewed([...prevChecked, id]);
        tempArr.push([...prevChecked, id]);
      } else {
        setRecentlyViewed([id]);
        tempArr.push([id]);
      }
    }
    localStorage.setItem('recent', tempArr);
  };
  useEffect(() => {
    if (recentlyViewed && recentlyViewed.length > 0) {
      localStorage.setItem('recent', recentlyViewed);
    }
  }, [recentlyViewed]);

  // Reset breakpoint on window resize.
  useEffect(() => {
    function handleResize() {
      setBreakpoint(getBreakpoint());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function isDateAfterToday(dateString: string): boolean {
    const year = +dateString.substring(0, 4);
    const month = +dateString.substring(5, 7);
    const day = +dateString.substring(8, 10);
    const date = new Date(year, month - 1, day);
    return new Date(date.toDateString()) > new Date(new Date().toDateString());
  }

  function getMandatoryFeeLabel(
    isResort: boolean | string,
    isLACountyFee: boolean,
    isMarketingFee: boolean,
    isDestinationFee: boolean
  ) {
    return isResort
      ? props.staticContent?.resortLabel + ' ' + props.staticContent?.feeLabel
      : isLACountyFee
      ? jsonContent?.surchargeCostsSearchLabel
      : isMarketingFee
      ? props.staticContent?.tourismMarketingFeeLabel
      : isDestinationFee
      ? props.staticContent?.destinationAmenityLabel + ' ' + props.staticContent?.feeLabel
      : '';
  }

  const currRateNode = props.flexibleOrManyProperty
    ? null
    : getCurrentPriceRateBlock(searchQueryState, props?.price?.node?.rates);
  const currRate = props.flexibleOrManyProperty ? null : getCurrRateAmountBlock(currRateNode);

  // get points block for the property card
  const currRatePoints = props?.flexibleOrManyProperty ? null : getCurrentRatePointsBlock(props?.price?.node?.rates);

  // check if the rates are present
  const isRatesPresent: boolean = determineIfRatesPresent(currRatePoints, currRate);

  const isPointsOnlyPresent: boolean | undefined =
    Object.keys(currRatePoints ?? {}).length > 0 && Object.keys(currRate ?? {}).length <= 0;

  //this useEffect is used to show taxes and fees on Mini Property card
  useEffect(() => {
    if (isRatesPresent) {
      //if rates and points both are present show taxes and fees
      setShowTaxesAndFees(true);
      if (isPointsOnlyPresent) {
        //if only points is present , hide  taxes and fees
        setShowTaxesAndFees(false);
      }
    } else {
      // if no rates and no points is there , hide taxes and fees
      setShowTaxesAndFees(false);
    }
  }, [props?.price?.node?.rates, isRatesPresent]);
  const mandateCurrentCurrency = props.searchQueryContextValue?.currentCurrency;

  let newMandatFee =
    props.flexibleOrManyProperty || !SM?.ALLOWED_DOMAINS?.includes(currentLocale as string)
      ? null
      : currRate?.mandatoryFees;
  if (mandateCurrentCurrency !== DefaultValue && SM?.ALLOWED_DOMAINS?.includes(currentLocale as string)) {
    newMandatFee = currRate?.mandatoryFees;
  }

  const mandatoryFeeResult = identifyTypeOfMandatoryFee(props.basicInformation);
  let { isResort } = mandatoryFeeResult;
  const { isLACountyFee, isMarketingFee, isDestinationFee } = mandatoryFeeResult;
  //if still isResort flag is empty then use resort Flag from uxl
  if (isResort === '') {
    isResort =
      props.flexibleOrManyProperty && props.selectedHotelData && props.selectedHotelData?.length
        ? props.selectedHotelData[0]?.node?.basicInformation?.resort
        : props.selectedHotelData[0]?.node?.property?.basicInformation?.resort;
  }

  const mandatoryFeeAvailable = () => {
    if (!SM?.ALLOWED_DOMAINS?.includes(currentLocale as string)) {
      return false;
    } else {
      return (
        !props?.flexibleOrManyProperty &&
        props?.ratesData &&
        props?.ratesData?.length > 0 &&
        props?.ratesData?.filter(
          (selectedHotel: { rateModes: { lowestAverageRate: { mandatoryFees: { amount: number } } } }) =>
            selectedHotel?.rateModes?.lowestAverageRate?.mandatoryFees &&
            selectedHotel?.rateModes?.lowestAverageRate?.mandatoryFees?.amount !== 0
        )?.length > 0
      );
    }
  };

  const tooltipArray = props.basicInformation?.descriptions
    ?.filter((item: { type: { code: string; enumCode: string }; text: string }) => {
      if (
        item?.type?.enumCode === mandatoryFeeCodes.resortFeeCode ||
        item?.type?.enumCode === mandatoryFeeCodes.destinationFeeCode ||
        item?.type?.enumCode === mandatoryFeeCodes.laCountyFeeCode ||
        item?.type?.enumCode === mandatoryFeeCodes.marketingFeeCode ||
        item?.text?.toLowerCase().includes(mandatoryFeeCodes.resortFeeCheck) ||
        item?.text?.toLowerCase().includes(mandatoryFeeCodes.destinationFeeCheck) ||
        item?.text?.toLowerCase().includes(mandatoryFeeCodes.laCountyFeeCheck)
      ) {
        return item;
      }
      return null;
    })[0]
    ?.text?.split('|');

  const displayToolTip = tooltipArray?.length && tooltipArray?.length;

  const currentViewIsTab = CommonUtils.isTabletView();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleTooltipClick = (event: any): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      props.handleTooltipClickOnCard(true);
    }
  };

  //this useEffect is used to determine if its an error state or not when map view is enabled
  useEffect(() => {
    let isHotelUnavailable = false;
    let isHotelMaxOccupancyExceeded = false;
    if (
      !props.isFlexibleDateSearch &&
      (currRateNode?.status?.code === STATUS_MAX_OCCUPANCY_EXCEEDED ||
        props.points?.status?.code === STATUS_MAX_OCCUPANCY_EXCEEDED ||
        props.EEOPriceInfo?.status?.code === STATUS_MAX_OCCUPANCY_EXCEEDED)
    ) {
      isHotelMaxOccupancyExceeded = true;
    } else if (
      !props.isFlexibleDateSearch &&
      !(currRateNode?.rateModes?.lowestAverageRate?.amount || props.points?.rateModes?.pointsPerUnit) &&
      props.selectedHotelData?.node?.property?.basicInformation?.openingDate &&
      (currRateNode?.status?.code === STATUS_NOT_AVAILABLE ||
        props.points?.status?.code === STATUS_NOT_AVAILABLE ||
        props.EEOPriceInfo?.status?.code === STATUS_NOT_AVAILABLE)
    ) {
      isHotelUnavailable = true;
    }
    const ratesData = props?.ratesData?.[0] ?? {};
    if (
      isErrorState &&
      (mandatoryFeeAvailable() ||
        (ratesData?.rateModes?.lowestAverageRate?.totalAmount &&
          ratesData?.rateModes?.lowestAverageRate?.totalAmount?.amount > 0) ||
        ratesData?.rateModes?.pointsPerUnit?.points > 0 ||
        ratesData?.rateModes?.lowestAverageRate?.amount ||
        props.isFlexibleDateSearch ||
        props.flexibleOrManyProperty ||
        isHotelMaxOccupancyExceeded ||
        isHotelUnavailable ||
        isAdultOnlyEdgeCaseTriggered)
    ) {
      // if these conditions are true , setting error state to false , as by default error state is true
      setIsErrorState(false);
    }
  }, [isMapViewEnabled, props]);

  let imageDimensions = {
    height: 120,
    width: 120,
  };
  if (!useCheckBreakpoint('viewportL')) {
    imageDimensions = {
      height: 245,
      width: 245,
    };
  }
  if (!useCheckBreakpoint('viewportM')) {
    imageDimensions = {
      height: 120,
      width: 120,
    };
  }

  /**
   * Construct a string with all arguments for square image processing.
   */
  const getSquareImgProcQueryString = useMemo(() => {
    return (
      `?output-quality=${outputQuality}&interpolation=${outputInterpolation};*,*&downsize=` +
      imageDimensions.width +
      'px:*'
    );
  }, [imageDimensions]);

  /**
   * Construct a string with all arguments for image processing.
   */
  const getImgProcQueryString = useMemo(() => {
    return (
      `?output-quality=${outputQuality}&interpolation=${outputInterpolation}&downsize=` + imageDimensions.width + 'px:*'
    );
  }, [imageDimensions]);

  /**
   * Construct a string with all arguments for image processing with cropping.
   */
  const getImgProcQueryStringWithCrop = useMemo(() => {
    return (
      `?output-quality=${outputQuality}&interpolation=${outputInterpolation}&crop=${
        imageDimensions.width * croppingRatio
      }:${imageDimensions.height * croppingRatio};*,*&downsize=` +
      imageDimensions.width +
      'px:*'
    );
  }, [imageDimensions]);

  const reviewsRedirectionURL = useRedirectionRules(
    props?.basicInformation?.brand?.id,
    props?.id,
    props?.name,
    reviewsRedirectionVarValue,
    currentLocale,
    seoNickName
  );

  const trcRedirectionURL = useRedirectionRules(
    props?.basicInformation?.brand?.id,
    props?.id,
    props?.name,
    trcRedirectionVarValue,
    currentLocale,
    seoNickName
  );

  // Function to open the HQV modal on click of hotel name on map pin and trigger satellite script.
  const openModal = async (propertyID: string) => {
    if (pageVal === 'chat' && onOpenHotelPanel) {
      onOpenHotelPanel(props?.selectedHotelData, propertyID);
    }
    resetDatalayerTracking();
    fetchAndSetSelectedPropertyData(
      setSearchResultsState,
      ratesDataFromStore?.ratesData,
      propertyID,
      props?.flexibleSearch ? true : false,
      continueCtaProperty
    );
    const pageNameURL = `${host}${addSubDirectoryPrefix(NAVIGATION_URL_CONSTANTS.SM_HOTEL_QUICK_VIEW_URL)}`;
    hqvDispatch({ type: HQV_ACTIONS.PROPERTY_SESSION_DATA, payload: sessionData });
    hqvDispatch({ type: HQV_ACTIONS.PROPERTY_IDENTITY, payload: propertyID });
    hqvDispatch({ type: HQV_ACTIONS.MODAL_OPEN_STATE, payload: true });
    if (window && window._satellite) {
      window._satellite['track']('hotelquickview', { pagename: pageNameURL, marsha: propertyID });
    }
    if (bodyRef.current) {
      bodyRef.current.style.height = '100vh';
      bodyRef.current.style.height = 'hidden';
    }
  };

  // **** Fallback Images dimensions change based on screen resolution ****
  const fallbackImageUrl = jsonContent?.squareFallBackImageURL + getSquareImgProcQueryString;
  const brandImageSrcUrl = props?.brandImageUrl ? props?.brandImageUrl + getImgProcQueryStringWithCrop : '';
  // **** Fallback Images dimensions change based on screen resolution end ****

  useEffect(() => {
    const recentlyChecked = localStorage.getItem('recent') || '';
    setRecentlyViewedFlag(recentlyChecked?.includes(props.id));
  }, [props.id]);

  const mandatoryFeeAvailability =
    !currentViewIsTab && mandatoryFeeAvailable() && !props.totalPrice?.amount && newMandatFee;

  const cardImageForMobile =
    props?.carouselImages?.primaryImage?.edges &&
    props?.carouselImages?.primaryImage?.edges.length &&
    props?.carouselImages?.primaryImage?.edges[0]?.node &&
    props?.carouselImages?.primaryImage?.edges[0]?.node.imageUrls
      ? imageDomain + props?.carouselImages?.primaryImage?.edges[0]?.node.imageUrls['square'] + getImgProcQueryString
      : brandImageSrcUrl;
  /**
   * Set the flag to true if the locale is Korea/Japan
   */
  const [secondaryTitle, setSecondaryTitle] = useState(false);
  useEffect(() => {
    if (isJpKoCnLocale(currentLocale)) {
      setSecondaryTitle(true);
    } else {
      setSecondaryTitle(false);
    }
  }, [currentLocale]);

  /**
   * get the distance in miles/km based on the locale
   */

  const hotelDistance = getCalculatedDistance(props?.distance, currentLocale !== hardCodedAllLocale?.en, currentLocale);
  const checkForTextDescriptor = () => {
    if (secondaryTitle && !props?.staticContent?.disableTextDescriptor) {
      return true;
    } else if (!secondaryTitle && !props?.staticContent?.disableTextDescriptor) {
      if (props.nameInDefaultLanguage === props?.name) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  return (
    <StyledHotelCard>
      <div
        className={`HotelCard ${props.index > 0 && 'Second-Card'} ${pageVal === 'chat' ? 'chat-hotel-card' : ''} ${
          props.index > 0 && props.hotelPromoLabel && 'Second-card-with-badge'
        } ${
          props.index > 0 &&
          props.hotelPromoLabel &&
          mandatoryFeeAvailability &&
          'Second-card-with-badge-and-mandate-fee'
        }`}
        tabIndex={0}
        id={`hotel-card-${props.cardIndex}`}
      >
        {(props.hotelPromoLabel || recentlyViewedFlag) &&
        (isViewportL || (width && width < BREAKPOINT_LARGER_MOBILE && isViewportXS && !isViewportM)) ? (
          <div
            tabIndex={0}
            role={'status'}
            aria-label={recentlyViewedFlag ? props?.staticContent?.recentlyViewedHeading : props.hotelPromoLabel}
          >
            <div className="hotel-card-no-promo-mobil"></div>
            <div className="hotel-card-promo">
              <div className="mx-0 t-label-alt-xs hotel-card-promo-label mb-1">
                {recentlyViewedFlag ? props?.staticContent?.recentlyViewedHeading : props.hotelPromoLabel}
              </div>
            </div>
          </div>
        ) : (
          <div className="hotel-card-no-promo-mob"></div>
        )}
        <div
          className={clsx(
            'row',
            'hotel-content',
            mandatoryFeeAvailability ? 'mandate-fee-corner' : '',
            searchQueryState.includeTaxesAndFees ? 'taxes-and-fees-corner' : ''
          )}
        >
          <div className={clsx('image-section')}>
            {!(width && width < BREAKPOINT_LARGER_MOBILE) && !isViewportL ? (
              <div className="hide-img-gallery">
                <ImageCarouselComponent
                  imageList={props?.carouselImages?.primaryImage?.edges}
                  propertyID={props?.id}
                  isFullyRenovated={props?.basicInformation?.isFullyRenovated}
                  isRecentlyRenovated={props?.basicInformation?.isRecentlyRenovated}
                  hasRenovatedRooms={props?.basicInformation?.hasRenovatedRooms}
                  newLobby={props?.basicInformation?.newLobby}
                  newProperty={props?.basicInformation?.newProperty}
                  idx={props?.idx}
                  brandCode={props?.basicInformation?.brand?.id}
                  recentlyViewedFlag={recentlyViewedFlag}
                  brandImageData={props?.basicInformation?.brand?.photos?.[0]?.content}
                  hotelName={props.name}
                  seoNickname={props?.seoNickname}
                  isMapView={true}
                  pageVal={pageVal}
                />
                {props?.basicInformation?.brand?.id && props?.basicInformation?.hasUniquePropertyLogo === false ? (
                  <div className="hotel-brand-container">
                    {featureFlagLogo?.experience_mcom_logo_automation ? (
                      <LogoContainer
                        brand={props?.basicInformation?.brand?.id}
                        aspectRatio={'3:2'}
                        width={125.83}
                        height={62}
                        alignment={'Bottom Left'}
                        isLink={false}
                        color={'background-aware'}
                        backgroundColor={LogoContainerBackgroundColor.Inverse}
                        brandFullName={props?.basicInformation?.brand?.name}
                      />
                    ) : (
                      <div
                        className={`icon-inverse brand-logo-container brand-logo-${props?.basicInformation?.brand?.id?.toUpperCase()}`}
                        aria-describedby={
                          props?.basicInformation?.brand?.id?.toUpperCase() === studioResCode
                            ? studisResCodeAriaLabel
                            : props?.basicInformation?.brand?.name
                        }
                      />
                    )}
                  </div>
                ) : (
                  ''
                )}
              </div>
            ) : (
              <>
                {!HWSBrands.includes(props?.basicInformation?.brand?.id) && (
                  <button
                    className="hqv-modal-opener HotelCard__image-container custom_click_track"
                    onClick={() => openModal(props?.id)}
                    {...{ custom_click_track_value: `${clickTrackingLoc}| Hotel Image Map |internal` }}
                  >
                    {cardImageForMobile && (
                      <img
                        src={cardImageForMobile}
                        alt="hotel view"
                        className="HotelCard__image"
                        onError={(e): void => {
                          e.cancelable && e.preventDefault();
                          if (!e.defaultPrevented) {
                            e.currentTarget.src = brandImageSrcUrl;
                            e.cancelable && e.preventDefault();
                          } else if (!e.isPropagationStopped()) {
                            e.currentTarget.src = fallbackImageUrl;
                            e.stopPropagation();
                          }
                        }}
                      />
                    )}
                    {!cardImageForMobile && (
                      <div
                        className="HotelCard__image-container unavailable-image-fallback"
                        aria-label={jsonContent?.fallBackImageAltText}
                      >
                        <img
                          className="HotelCard__image"
                          src={fallbackImageUrl}
                          alt={jsonContent?.fallBackImageAltText}
                          height={imageDimensions.height}
                          width={imageDimensions.width}
                        />
                        <div className="image-unavailable-text t-font-inverse-xs">
                          {jsonContent?.imageUnavailableLabel}
                        </div>
                        <div className="scrim-component" />
                      </div>
                    )}
                  </button>
                )}
                {HWSBrands.includes(props?.basicInformation?.brand?.id) && (
                  <a
                    href={trcRedirectionURL}
                    target="_blank"
                    rel="noreferrer"
                    className={clsx(
                      'HotelCard__image-container',
                      'custom_click_track',
                      getClassForBreakpoint(breakpoint, 't-subtitle-xl', 't-subtitle-l', 't-subtitle-m')
                    )}
                    {...{ custom_click_track_value: `${clickTrackingLoc}| Hotel Image Map |internal` }}
                  >
                    {cardImageForMobile && (
                      <img
                        src={cardImageForMobile}
                        alt="hotel view"
                        className="HotelCard__image"
                        onError={(e): void => {
                          e.cancelable && e.preventDefault();
                          if (!e.defaultPrevented) {
                            e.currentTarget.src = brandImageSrcUrl;
                            e.cancelable && e.preventDefault();
                          } else if (!e.isPropagationStopped()) {
                            e.currentTarget.src = fallbackImageUrl;
                            e.stopPropagation();
                          }
                        }}
                      />
                    )}
                    {!cardImageForMobile && (
                      <div
                        className="HotelCard__image-container unavailable-image-fallback"
                        aria-label={jsonContent?.fallBackImageAltText}
                      >
                        <img
                          className="HotelCard__image"
                          src={fallbackImageUrl}
                          alt={jsonContent?.fallBackImageAltText}
                          height={imageDimensions.height}
                          width={imageDimensions.width}
                        />
                        <div className="image-unavailable-text t-font-inverse-xs">
                          {jsonContent?.imageUnavailableLabel}
                        </div>
                        <div className="scrim-component" />
                      </div>
                    )}
                  </a>
                )}
              </>
            )}
          </div>

          <div className={clsx('color-scheme1', 'hotel-card-text-section')}>
            <div className={clsx('HotelCard__top-section')}>
              <h5
                className={clsx(
                  isViewportM && !isViewportL ? 't-subtitle-l' : 't-subtitle-m',
                  'HotelCard__top-section_title',
                  finalPrice && finalPrice?.split('')?.length > 3 && nameElipsis ? 'name-ellipsis' : ''
                )}
                tabIndex={-1}
              >
                {!HWSBrands.includes(props?.basicInformation?.brand?.id) && (
                  <div
                    className={clsx('HotelCard__top-section_title-section', 'hqv-modal-opener', 'custom_click_track')}
                    {...{
                      custom_click_track_value: `${clickTrackingLoc}| ${props.name} |internal`,
                    }}
                    onClick={() => openModal(props?.id)}
                    tabIndex={0}
                    role="button"
                    aria-label={props.name}
                  >
                    <div className={clsx(checkForTextDescriptor() && 'minicard-primary-title')}>{props.name}</div>

                    {props?.nameInDefaultLanguage !== props?.name && secondaryTitle && (
                      <div className={clsx('py-1', 'minicard-secondary-title')}>{props?.nameInDefaultLanguage}</div>
                    )}
                    {props?.nameInDefaultLanguage === props?.name && !props?.staticContent?.disableTextDescriptor && (
                      <div className={clsx('py-1', 'minicard-secondary-title', 'minicard-text-descriptor')}>
                        {props?.staticContent?.descriptorSearchLabel}
                      </div>
                    )}
                  </div>
                )}
                {HWSBrands.includes(props?.basicInformation?.brand?.id) && (
                  <a
                    href={trcRedirectionURL}
                    rel="noreferrer"
                    target="_blank"
                    className={clsx('HotelCard__top-section_title-section', 'custom_click_track')}
                    {...{ custom_click_track_value: `${clickTrackingLoc}| ${props.name} |internal` }}
                  >
                    <div className={clsx(checkForTextDescriptor() && 'minicard-primary-title')}>{props.name}</div>
                    {props?.nameInDefaultLanguage !== props?.name && secondaryTitle && (
                      <div className={clsx('py-1 minicard-secondary-title')}>{props?.nameInDefaultLanguage}</div>
                    )}
                    {props?.nameInDefaultLanguage === props?.name && !props?.staticContent?.disableTextDescriptor && (
                      <div className={clsx('py-1', 'minicard-secondary-title', 'minicard-text-descriptor')}>
                        {props?.staticContent?.descriptorSearchLabel}
                      </div>
                    )}
                  </a>
                )}
              </h5>

              <div className="HotelCard__top-section_reviewsAndDistance">
                {props?.otherPropertyInformation?.isAllInclusive &&
                  localeToShowAllInclusiveBadge.includes(currentLocale) && (
                    <Badge
                      badgeVariation={BadgeVariation.Inline}
                      badgeText={jsonContent?.allInclusiveLabel}
                      customClass="hotel-card-all-inclusive-tag"
                    />
                  )}
                {props?.totalReviews > 0 && !props?.isMax ? (
                  <PropertyRatingContainer
                    propertyReviewUrl={
                      HWSBrands.includes(props?.basicInformation?.brand?.id) ? trcRedirectionURL : reviewsRedirectionURL
                    }
                    disabled={isReviewCountHidden(currentLocale)}
                    target="_blank"
                    rel="noreferrer"
                    tooltipPosition={!isViewPortXL && isViewportM ? TOOLTIP_POSITION.bottom : TOOLTIP_POSITION.default}
                    toolTipContent={CN_RATING_TOOLTIP}
                    className={clsx(
                      't-font-alt-xs',
                      'HotelCard__top-section_reviews',
                      'custom_click_track',
                      getClassForBreakpoint(breakpoint, 't-subtitle-xl', 't-subtitle-l', 't-subtitle-m')
                    )}
                    {...{ custom_click_track_value: `${clickTrackingLoc}| Hotel Image Map |internal` }}
                  >
                    <div>
                      {props.stars && props.stars !== null && (
                        <div
                          className={ratingContainer}
                          aria-label={`${props.stars} stars out of 5 for ${props.totalReviews} reviews`}
                          role="document"
                        >
                          <div className="m-ratings-stars mr-1">
                            <span
                              className={'icon-alt ' + (props.stars < 2.5 ? 'icon-star-half-fill' : 'icon-star-fill')}
                            />
                          </div>
                          <span className="mr-2">{formatNumberByLocale(props.stars, currentLocale)}</span>

                          <PropertyReview
                            className={'mr-2 star-reviews-container'}
                            isVisible={!isReviewCountHidden(currentLocale)}
                          >
                            <span className="reviews-number">
                              ({formatNumberByLocale(props.totalReviews, currentLocaleLang)}
                              <span className="reviews-label">{props.staticContent.reviewsLabel}</span>)
                            </span>
                          </PropertyReview>
                        </div>
                      )}
                    </div>
                  </PropertyRatingContainer>
                ) : (
                  ''
                )}
                {props?.totalReviews > 0 && props?.distance >= 0 && props?.distance !== null && !props?.isMax ? (
                  <div className={clsx('divider-section', 't-font-alt-xs')}> |&nbsp;</div>
                ) : (
                  ''
                )}
                {/* hide/show distance on mini property card based on hotellist param */}
                {enableHotelList() === true
                  ? ''
                  : props?.distance >= 0 &&
                    props?.distance !== null && (
                      <div
                        className={clsx(
                          'HotelCard__top-section_distance',
                          props?.otherPropertyInformation?.isAllInclusive && 'with-all-inclusive'
                        )}
                      >
                        <div className={clsx('m-icon-text')}>
                          <span className={clsx('icon-alt', 'icon-location', 'icon-s')}></span>
                          <span className={clsx('t-font-alt-xs')}>
                            {hotelDistance} {props.staticContent?.unitFromDestinationLabel}
                          </span>
                        </div>
                      </div>
                    )}
              </div>
            </div>
            <div className="HotelCard__mid-section">
              <p
                className={`t-font-alt-xs HotelCard__mid-section_description ${
                  showStrikeThroughPrice &&
                  (mandatoryFeeAvailable() || (finalPrice && finalPrice?.split('')?.length > 3)) &&
                  'description-ellipsis'
                }`}
              >
                {props.description}
              </p>
              {!HWSBrands.includes(props?.basicInformation?.brand?.id) && (
                <button
                  onClick={() => openModal(props?.id)}
                  className="m-link-tertiary-button HotelCard__mid-section_details custom_click_track hqv-modal-opener "
                  {...{ custom_click_track_value: `${clickTrackingLoc}| Hotel Details Page Map |internal` }}
                >
                  {props.staticContent.viewDetailsLabel}
                </button>
              )}
              {HWSBrands.includes(props?.basicInformation?.brand?.id) && (
                <a
                  href={trcRedirectionURL}
                  target="_blank"
                  rel="noreferrer"
                  className={clsx(
                    'm-link-tertiary-button',
                    'HotelCard__mid-section_details',
                    'custom_click_track',
                    getClassForBreakpoint(breakpoint, 't-subtitle-xl', 't-subtitle-l', 't-subtitle-m')
                  )}
                  {...{ custom_click_track_value: `${clickTrackingLoc}| Hotel Image Map |internal` }}
                >
                  {props.staticContent.viewDetailsLabel}
                </a>
              )}
            </div>
            <div
              className={clsx(
                props.hotelUnavailable
                  ? `hotel-card-unavilable ${
                      (props?.flexibleSearch ||
                        props?.flexibleOrManyProperty ||
                        props?.noRatesAvailableForAnyProperty) &&
                      !isFutureDate &&
                      (!isViewportM || isViewportL)
                        ? 'no-line'
                        : ''
                    }`
                  : `HotelCard__bottom-section ${
                      (props.flexibleSearch || props.flexibleOrManyProperty) &&
                      !isFutureDate &&
                      (!isViewportM || isViewportL) &&
                      'no-line'
                    }`,
                props.adultsOnly && props.childCount > 0 ? 'adult-only' : ''
              )}
            >
              {!props.noRatesAvailableForAnyProperty && (
                <div className="edge-cases">
                  {props.isErrorState && !isAdultOnlyEdgeCaseTriggered && !props.hotelUnavailable && (
                    <>
                      <div className="error-state-triggered edge-case hotel-unavailable">
                        <div
                          className={clsx(
                            getClassForBreakpoint(breakpoint, 't-font-alt-xs', 't-font-alt-xs', 't-font-alt-xs'),
                            ' unavailable-text '
                          )}
                        >
                          {props.staticContent?.rateUnavailableLabel}&nbsp;
                        </div>
                        <a
                          href={
                            addSubDirectoryPrefix(props.availabilityUrl) +
                            '&isSearch=true&currency=' +
                            (searchQueryState.currentCurrency === 'default' ? '' : searchQueryState.currentCurrency) +
                            '&showFullPrice=' +
                            searchQueryState.includeTaxesAndFees +
                            (searchQueryState.currentCurrency === 'default' ? '' : '&redirectedFromSERP=true')
                          }
                          className="cta-button custom_click_track view-availablity"
                          {...{
                            custom_click_track_value: `${clickTrackingLoc}| View Other Dates Button Map |internal`,
                          }}
                          tabIndex={-1}
                        >
                          <button type="button" className="m-button-s m-button-secondary show-availability-button">
                            {continueCtaProperty === props.id
                              ? props.staticContent?.continueText
                              : props.staticContent?.showAvailabilityLabel}
                          </button>
                        </a>
                      </div>
                      {(edgeCaseTriggered = true)}
                    </>
                  )}
                  {isFutureDate && (props?.isFlexibleDateSearch || !isRatesPresent) && !edgeCaseTriggered && (
                    <div className={clsx('t-font-alt-xs', 'edge-case', 'opening-soon')}>
                      {formatOpeningSoonDate(
                        jsonContent.openingSoonLabel,
                        openingDate,
                        jsonContent?.openingSoonDateFormat,
                        currentLocale
                      )}
                      {props.isHotelBookable && (
                        <a
                          href={
                            addSubDirectoryPrefix(props.availabilityUrl) +
                            '&isSearch=true&currency=' +
                            (searchQueryState.currentCurrency === 'default' ? '' : searchQueryState.currentCurrency) +
                            '&showFullPrice=' +
                            searchQueryState.includeTaxesAndFees +
                            (searchQueryState.currentCurrency === 'default' ? '' : '&redirectedFromSERP=true')
                          }
                          className={clsx('cta-button', 'custom_click_track', 'view-availablity')}
                          {...{
                            custom_click_track_value: `${clickTrackingLoc}| View Other Dates Button Map |internal`,
                          }}
                          tabIndex={-1}
                        >
                          <button
                            type="button"
                            className={clsx('m-button-s', 'm-button-secondary', 'show-availability-button')}
                          >
                            {continueCtaProperty === props.id
                              ? props.staticContent?.continueText
                              : props.staticContent?.showAvailabilityLabel}
                          </button>
                        </a>
                      )}
                      {(edgeCaseTriggered = true)}
                    </div>
                  )}

                  {props.isHotelBookable &&
                    !props.noRatesAvailableForAnyProperty &&
                    props.statusCode !== STATUS_MAX_OCCUPANCY_EXCEEDED &&
                    props.hotelUnavailable &&
                    !edgeCaseTriggered &&
                    !props.flexibleSearch &&
                    !isAdultOnlyEdgeCaseTriggered && (
                      <>
                        <div className="edge-case hotel-unavailable">
                          <div
                            className={
                              (!isViewportM && isViewportL ? 't-font-alt-xs' : 't-font-alt-s') + ' unavailable-text '
                            }
                          >
                            {props.hotelUnavailableLabel}&nbsp;
                          </div>
                          <a
                            href={
                              addSubDirectoryPrefix(props.availabilityUrl) +
                              '&isSearch=true&currency=' +
                              (searchQueryState.currentCurrency === 'default' ? '' : searchQueryState.currentCurrency) +
                              '&showFullPrice=' +
                              searchQueryState.includeTaxesAndFees +
                              (searchQueryState.currentCurrency === 'default' ? '' : '&redirectedFromSERP=true')
                            }
                            className="cta-button custom_click_track"
                            {...{
                              custom_click_track_value: `${clickTrackingLoc}| View Other Dates Button Map |internal`,
                            }}
                            tabIndex={-1}
                          >
                            <button type="button" className="m-button-s m-button-secondary show-availability-button">
                              {continueCtaProperty === props.id
                                ? props.staticContent?.continueText
                                : props.staticContent?.showAvailabilityLabel}
                            </button>
                          </a>
                        </div>
                        {(edgeCaseTriggered = true)}
                      </>
                    )}
                  {!props.flexibleSearch &&
                    props.statusCode === STATUS_NOT_AVAILABLE &&
                    !edgeCaseTriggered &&
                    !isAdultOnlyEdgeCaseTriggered && (
                      <>
                        <div className={clsx('t-font-alt-s')}>
                          {props.isSpecialRateSearch
                            ? props.staticContent?.rateUnavailableLabel
                            : props.staticContent?.soldOutLabel}
                        </div>
                        {(edgeCaseTriggered = true)}
                      </>
                    )}
                  {!props.flexibleSearch &&
                    props?.hotelUnavailable &&
                    props.isHotelBookable &&
                    !edgeCaseTriggered &&
                    !isAdultOnlyEdgeCaseTriggered && (
                      <>
                        <div className={clsx('t-font-alt-s')}>
                          {props.isSpecialRateSearch
                            ? props.staticContent?.rateUnavailableLabel
                            : props.staticContent?.soldOutLabel}
                        </div>
                        {(edgeCaseTriggered = true)}
                      </>
                    )}
                  {!props.isHotelBookable && !edgeCaseTriggered && (
                    <div
                      className={clsx(
                        getClassForBreakpoint(breakpoint, 't-font-alt-xs', 't-font-alt-s', 't-font-alt-xs'),
                        ' edge-case call-to-book '
                      )}
                    >
                      {props.calltoBookLabel}
                      {(edgeCaseTriggered = true)}
                    </div>
                  )}
                  {props.adultsOnly && props.childCount > 0 && !edgeCaseTriggered && (
                    <>
                      <div
                        className={
                          (!isViewportM && isViewportL ? 't-label-xs' : 't-font-alt-s') +
                          ' edge-case adult-only-property'
                        }
                      >
                        <div className="adult-only-message">{props?.adultsOnlyMessageLabel}</div>
                        <div className="remove-children-message">{` ${props?.staticContent?.removeChildrenMessageShort}`}</div>
                        <div className="adult-only-message-for-desktop">{` ${props?.removeChildrenMessage}`}</div>
                      </div>
                      {(edgeCaseTriggered = true)}
                    </>
                  )}
                  {!props.flexibleSearch &&
                    props.statusCode === STATUS_MAX_OCCUPANCY_EXCEEDED &&
                    !edgeCaseTriggered && (
                      <>
                        <div className={clsx('t-font-alt-xs', 'hotel-card-max-occ-height')}>
                          <div className={clsx('t-font-alt-s edit-guest')}>
                            <span className="maximum-guest-label">{props.maximumGuestsExceededLabel}</span>{' '}
                            <span className="edit-guest-label">{props.editGuestsOrRoomsLabel}</span>
                          </div>
                          {(isViewportL || (isViewportXS && !isViewportM)) && (
                            <span className={clsx('edit-rates-label')}>{props.editToSeeRatesLabel}</span>
                          )}
                        </div>
                        {(edgeCaseTriggered = true)}
                      </>
                    )}
                </div>
              )}
              {props.noRatesAvailableForAnyProperty && !props.isFlexibleDateSearch && (
                <div className={clsx('error-state-triggered', 'edge-case', 'hotel-unavailable')}>
                  <a
                    href={addSubDirectoryPrefix(props.ratesUrl)}
                    className={clsx('view-rates-button-container', 'custom_click_track')}
                    {...{ custom_click_track_value: `${clickTrackingLoc}| View Rates Map |internal` }}
                    tabIndex={-1}
                  >
                    <button type="button" className={clsx('m-button-s', 'm-button-primary', 'view-rates-button')}>
                      {continueCtaProperty === props.id
                        ? props.staticContent?.continueText
                        : props.staticContent?.viewRateLabel}
                    </button>
                  </a>
                </div>
              )}
              {((!props.hotelUnavailable && !edgeCaseTriggered) ||
                (props.isHotelBookable && props.flexibleSearch && !isFutureDate && !edgeCaseTriggered)) && (
                <>
                  <div
                    className={clsx('price-container')}
                    data-testid={'hotel-card-testid'}
                    onClick={(): void => handlePropertyClicked(props.id)}
                  >
                    <div className={clsx('price-sub-section')}>
                      <PropertyCardPriceSection
                        searchQueryContextValue={props?.searchQueryContextValue}
                        staticDataContextValue={props?.staticContent}
                        propertyCardData={{ ...props.price }}
                        fromHotelCard={true}
                        flexibleSearch={props.flexibleSearch}
                        isSpecialRateSearch={props.isSpecialRateSearch}
                        flexibleOrManyProperty={props.flexibleOrManyProperty}
                        recentlyviewedRibbon={handlePropertyClicked}
                        showStrikeThroughPrice={showStrikeThroughPrice}
                        setShowStrikeThroughPrice={setShowStrikeThroughPrice}
                        setFinalPrice={setFinalPrice}
                        currentLocaleLang={currentLocaleLang}
                        handleTooltipClick={handleTooltipClick}
                        toolTipList={tooltipArray}
                      />
                      {/* Mandatory Amenities Fees section */}
                      {currentViewIsTab &&
                        mandatoryFeeAvailable() &&
                        getMandatoryFeeLabel(isResort, isLACountyFee, isMarketingFee, isDestinationFee) !== '' &&
                        !props.points?.rateModes?.pointsPerUnit &&
                        !props.totalPrice?.amount &&
                        !((isLACountyFee || isMarketingFee) && currRatePoints) &&
                        newMandatFee && (
                          <div className="mandatory-fee-section-list-view">
                            <div className="includes-fee" onKeyDown={(e): void => handleTooltipClick(e)}>
                              {props.staticContent?.includesLabel}{' '}
                              {getPriceByDecimalPoint(
                                newMandatFee.amount,
                                newMandatFee.decimalPoint,
                                props.searchQueryContextValue,
                                currentLocaleLang,
                                newMandatFee?.currency
                              )}{' '}
                              {mandateCurrentCurrency !== DefaultValue ? mandateCurrentCurrency : newMandatFee.currency}
                            </div>
                            <div>
                              <span
                                role="generic"
                                onClick={(e): void => handleTooltipClick(e)}
                                className={clsx(
                                  'm-link-icon-button-info',
                                  'custom-info-map',
                                  'analytics-click',
                                  'custom_click_track',
                                  !displayToolTip ? 'remove-info-icon' : ''
                                )}
                                {...{
                                  custom_click_track_value: `${clickTrackingLoc}| Mandatory Fee Tooltip Button Mini Property Card |internal`,
                                }}
                              >
                                <span className="mandatory-fee-label-text">
                                  {getMandatoryFeeLabel(isResort, isLACountyFee, isMarketingFee, isDestinationFee)}
                                </span>
                              </span>
                            </div>
                          </div>
                        )}
                    </div>
                    <a
                      href={addSubDirectoryPrefix(props.ratesUrl)}
                      className="view-rates-button-container custom_click_track"
                      {...{ custom_click_track_value: `${clickTrackingLoc}| View Rates Map |internal` }}
                      tabIndex={-1}
                    >
                      <button type="button" className="m-button-s m-button-primary view-rates-button">
                        {continueCtaProperty === props.id
                          ? props.staticContent?.continueText
                          : props.staticContent?.viewRateLabel}
                      </button>
                    </a>
                    {/* Chat arrow icon */}
                    {pageVal === 'chat' && <span className="chat-arrow-icon icon-arrow-right" aria-hidden="true" />}
                  </div>
                  {(edgeCaseTriggered = true)}
                </>
              )}
            </div>
          </div>
          {/* Mandatory Amenities Fees section */}
          {props.adultsOnly && props.childCount > 0
            ? ''
            : !currentViewIsTab &&
              mandatoryFeeAvailable() &&
              getMandatoryFeeLabel(isResort, isLACountyFee, isMarketingFee, isDestinationFee) !== '' &&
              !props.totalPrice?.amount &&
              !props.flexibleSearch &&
              !props.hotelUnavailable &&
              props.isHotelBookable &&
              !((isLACountyFee || isMarketingFee) && currRatePoints) &&
              newMandatFee && (
                <div className={clsx('mandatory-fee-section', 'col-md-12')}>
                  <span
                    onClick={(e): void => handleTooltipClick(e)}
                    onKeyDown={(e): void => handleTooltipClick(e)}
                    role="button"
                    tabIndex={0}
                    aria-label={`${props?.staticContent?.includesLabel} ${getPriceByDecimalPoint(
                      newMandatFee?.amount,
                      newMandatFee?.decimalPoint,
                      props?.searchQueryContextValue,
                      currentLocaleLang,
                      newMandatFee?.currency
                    )} ${
                      mandateCurrentCurrency !== DefaultValue ? mandateCurrentCurrency : newMandatFee?.currency
                    } ${getMandatoryFeeLabel(isResort, isLACountyFee, isMarketingFee, isDestinationFee)}
                      `}
                    className={clsx(
                      'm-link-icon-button-info',
                      'custom-info',
                      'analytics-click',
                      'custom_click_track',
                      !displayToolTip ? 'remove-info-icon' : '',
                      isLACountyFee &&
                        getPriceByDecimalPoint(
                          newMandatFee.amount,
                          newMandatFee.decimalPoint,
                          props.searchQueryContextValue,
                          currentLocaleLang,
                          newMandatFee?.currency
                        )
                          ?.toString()
                          ?.split('')?.length > 5
                        ? 'la-map-tooltip-adjustment'
                        : ''
                    )}
                    {...{
                      custom_click_track_value: `${clickTrackingLoc}| Mandatory Fee Tooltip Button Mini Property Card |internal`,
                    }}
                  >
                    {!props.points?.rateModes?.pointsPerUnit ? (
                      <>
                        {props.staticContent?.includesLabel}{' '}
                        {getPriceByDecimalPoint(
                          newMandatFee.amount,
                          newMandatFee.decimalPoint,
                          props.searchQueryContextValue,
                          currentLocaleLang,
                          newMandatFee?.currency
                        )}{' '}
                        {mandateCurrentCurrency !== DefaultValue ? mandateCurrentCurrency : newMandatFee?.currency}{' '}
                        {getMandatoryFeeLabel(isResort, isLACountyFee, isMarketingFee, isDestinationFee)}
                      </>
                    ) : (
                      <>
                        +{' '}
                        {getPriceByDecimalPoint(
                          newMandatFee.amount,
                          newMandatFee.decimalPoint,
                          props.searchQueryContextValue,
                          currentLocaleLang,
                          newMandatFee?.currency
                        )}{' '}
                        {mandateCurrentCurrency !== DefaultValue ? mandateCurrentCurrency : newMandatFee?.currency}{' '}
                        {props.staticContent?.dailyLabel}{' '}
                        {getMandatoryFeeLabel(isResort, isLACountyFee, isMarketingFee, isDestinationFee)}
                      </>
                    )}
                  </span>
                </div>
              )}

          {(props.adultsOnly && props.childCount > 0) || props.statusCode === STATUS_MAX_OCCUPANCY_EXCEEDED ? (
            ''
          ) : !currentViewIsTab &&
            showFullPriceInMiniCard &&
            !props.flexibleSearch &&
            !props.hotelUnavailable &&
            !props.flexibleOrManyProperty &&
            props.isHotelBookable &&
            !isFutureDate &&
            showTaxesAndFees ? (
            <div tabIndex={0} role="status" className={clsx('include-tax-section', 'col-md-12')}>
              <div className={clsx('t-font-xs', 'taxes-and-fees-included')}>
                {props.staticContent?.taxesAndFeesIncluded}
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </StyledHotelCard>
  );
};

export default HotelCard;
